'use client';

import { cn } from '@/lib/utils';
import { newsletterSchema } from '@/lib/validationSchema';
import { zodResolver } from '@hookform/resolvers/zod';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import * as z from 'zod';
import Button from '../ui/Button';
import Input from '../ui/Input';

type FormData = z.infer<typeof newsletterSchema>;

export default function NewsletterForm({ className }: { className?: string }) {
    const t = useTranslations();
    const [successMessage, setSuccessMessage] = useState<boolean>(false);

    const {
        handleSubmit,
        register,
        reset,
        formState: { errors },
    } = useForm<FormData>({
        resolver: zodResolver(newsletterSchema),
    });

    const onSubmit = async (data: FormData) => {
        console.log('onSubmit data:', data);

        const formData = new FormData();
        formData.append('formType', 'newsletter');
        formData.append('email', data.email);

        try {
            const response = await fetch('/submit-form.php', {
                method: 'POST',
                body: formData,
            });

            if (response.ok) {
                const result = await response.json();
                console.log('Form submission result:', result);
                setSuccessMessage(true);
            } else {
                console.error('Form submission failed:', response.statusText);
            }

            reset();
        } catch (error) {
            console.error('Error submitting form:', error);
        }
    };

    return (
        <form
            className={cn(
                'flex pb-4 border-b border-white justify-between [&>div]:self-center',
                className,
            )}
            onSubmit={handleSubmit(onSubmit)}
            id="newsletter-form-trigger"
        >
            <div className="relative w-full">
                <Input
                    {...register('email')}
                    type="email"
                    placeholder={t('Footer.yourEmail')}
                    autoComplete="false"
                    error={
                        errors['email']?.message ? t(`FieldErrors.${errors['email']?.message}`) : ''
                    }
                    className="newsletter-input text-white placeholder-light-grey border-none w-full mr-2"
                />
                {successMessage && (
                    <div className="absolute -bottom-16 text-brand">
                        {t('Form.submissionSuccessShort')}
                    </div>
                )}
            </div>
            <Button
                className="w-fit h-fit text-nowrap"
                title={t('Buttons.send')}
                variant="primary"
                withArrow
                type="submit"
            />
        </form>
    );
}
